import { render, staticRenderFns } from "./QueryPolicyTotals.vue?vue&type=template&id=100d9d60&"
import script from "./QueryPolicyTotals.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports